import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

interface StoreCardProps {
    title: string;
    icon: React.ReactNode;
    children: React.ReactNode;
    emptyMessage?: string;
    isEmpty?: boolean;
}

const StoreCard = ({ title, icon, children, emptyMessage, isEmpty }: StoreCardProps) => (
    <Card>
        <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                {icon}
                <Typography variant="h6" component="h2" sx={{ ml: 1 }}>
                    {title}
                </Typography>
            </Box>
            {isEmpty ? (
                <Typography variant="body2" color="text.secondary">
                    {emptyMessage}
                </Typography>
            ) : (
                children
            )}
        </CardContent>
    </Card>
);

export default StoreCard;
